import { CLEAR_SITE_DATA } from '../application';
import { SET_CREATING_BOOKMARK } from './actions';

const initialState = {
  bookmarks: {},
  loaded: false,
  isCreating: false,
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case SET_CREATING_BOOKMARK: {
      return { ...state, isCreating: action.isCreating };
    }
    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }
    default: {
      return state;
    }
  }
}
